'use-client'

import { Box, Link } from '@mui/material'
import getYouTubeID from 'get-youtube-id'

import { useTranslations } from '@/hooks/useTranslations'

import type { FC } from 'react'
import type { PortableTextTypeComponentProps } from '@portabletext/react'
import type { Youtube } from '@/gen/sanity/schema'

interface SanityBlockContentYoutubeProps {
  portableTextImageProps: PortableTextTypeComponentProps<Youtube>
}

export const SanityBlockContentYoutube: FC<SanityBlockContentYoutubeProps> = ({ portableTextImageProps }) => {
  const { translate } = useTranslations()
  const youtube = portableTextImageProps.value

  if (youtube.url == null) {
    return <></>
  }

  const id = getYouTubeID(youtube.url)
  const url = `https://www.youtube.com/embed/${id}?rel=0`
  const youtubeWidth = youtube.resize === 'widthResize' && youtube.width ? youtube.width + '%' : '100%'

  const handleClick = () => {
    if (typeof window !== 'undefined' && typeof window.Cookiebot !== 'undefined') {
      window.Cookiebot.renew()
    }
  }

  const sxProps = {
    width: youtubeWidth,
    aspectRatio: '16/9',
    overflow: 'hidden',
    my: 2,
  }
  if (!url) {
    return <></>
  }

  return (
    <Box
      position="relative"
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: youtube?.videoPlacement,
      }}
    >
      <Box position="relative" sx={{ ...sxProps }}>
        <Box className="cookieconsent-optout-marketing">
          {translate('youtube.cookie.consentLink', {
            link: (
              <Link sx={{ cursor: 'pointer' }} onClick={handleClick}>
                {translate(`youtube.cookie.consent.link`)}
              </Link>
            ),
          })}
        </Box>
        <iframe
          data-cookieblock-src={url}
          data-cookieconsent="marketing"
          title="YouTube Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          width="100%"
          height="100%"
        />
      </Box>
    </Box>
  )
}
